import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const uploadPptShotClass = (
  classId,
  fileExtension,
  isVariant,
  status,
  data
) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.UPLOAD_PPT_SHOTCLASS(
      classId,
      fileExtension,
      isVariant,
      status
    ),
    data
  );
};

export default uploadPptShotClass;
